import { useTranslation } from 'react-i18next';
import { parse } from 'query-string';
import { useLocation } from 'react-router-dom';
import { flatten } from 'lodash-es';

import { useDateDropdownValue } from '@/services/hooks/useDateDropdownValue';
import { useDateDropdownOptions } from '../useDateDropdownOptions';
import { MobileFilterTabsProps } from '../../CampaignsInterface';
import { getCampaignTypeOptions } from '../../CampaignsList/config';

export const useMobileFilterTabs = (): MobileFilterTabsProps[] => {
    const { t } = useTranslation();
    const dateOptions = useDateDropdownOptions();
    const dateRangeValue = useDateDropdownValue(true);
    const location = useLocation();
    const query = parse(location.search);
    const startDate = query?.from?.toString();
    const endDate = query?.to?.toString();
    const typesOptions = getCampaignTypeOptions();
    const urlTypes: string[] = query?.type ? flatten([query?.type]) : [];

    return [
        {
            label: t('daterange'),
            defaultValue: dateRangeValue as string,
            options: dateOptions,
            type: 'date',
            startDate,
            endDate,
        },
        {
            defaultCheckboxValue: urlTypes,
            label: t('type'),
            options: typesOptions,
            type: 'checkbox',
        },
    ];
};
